import DOMPurify from 'dompurify';

import { resolveMediaUrl } from '@/lib/api';

// Força rel="noopener noreferrer" em links target="_blank" (anti reverse-tabnabbing)
// e resolve imagens servidas pelo backend (/uploads) para a origem correta.
let hooksInstalled = false;
function installHooks() {
  if (hooksInstalled) return;
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
      node.setAttribute('rel', 'noopener noreferrer');
    }
    if (node.tagName === 'IMG') {
      const src = node.getAttribute('src');
      if (src) node.setAttribute('src', resolveMediaUrl(src));
      node.setAttribute('loading', 'lazy');
    }
  });
  hooksInstalled = true;
}

/**
 * Sanitiza HTML de conteúdo autoral (posts do Blog) antes de renderizar com
 * dangerouslySetInnerHTML. Permite tags/atributos de formatação rica segura
 * (inclui imagens e tabelas); o DOMPurify remove scripts, handlers de evento
 * (onerror etc.) e protocolos perigosos (javascript:) por padrão.
 */
export function sanitizeHtml(html: string): string {
  installHooks();
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'ul', 'ol', 'li',
      'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'code', 'pre', 'span', 'hr',
      'img',
      'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'caption', 'colgroup', 'col',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'title', 'width', 'height', 'colspan', 'rowspan'],
    ALLOW_DATA_ATTR: false,
  });
}
